import { useMemo } from 'react';
import { useGetEditOrActual } from './useGetEditOrActual';

export const useCampaignSettingsSelector = () => {
  const state = useGetEditOrActual();

  return useMemo(
    () => ({
      name: state.name ?? state.name,
      status: state.status ?? state.status,
      allowList: state.allowList ?? state.allowList,
      emailAllowList: state.emailAllowList ?? state.emailAllowList,
      lookBackPeriod: state.lookBackPeriodInMinutes,
      scheduling: state.scheduling,
    }),
    [state.allowList, state.emailAllowList, state.lookBackPeriodInMinutes, state.name, state.status, state.scheduling],
  );
};
